import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { FollowQueryKey } from '../helpers/queryKeys'

import { getFollowStatistics } from '../services/getFollowStatistics'

export type TFollowStatistics = {
    followers_count: number
    following_count: number
}

const EMPTY_STATISTICS: TFollowStatistics = { followers_count: 0, following_count: 0 }

/**
 * Follower/following counts for a single author. `follow/stats` is batch-shaped — ids go in
 * `_`-prefixed, the response is keyed by the bare username — so we send one id and read it back by
 * username. Per-username for now; cross-username coalescing can move behind this hook later without
 * touching callers.
 */
export const useFollowStatistics = (username: string, enabled = true) => {
    return useQuery({
        queryKey: FollowQueryKey.followStatistics(username),
        queryFn: async ({ signal }) => {
            const result = await getFollowStatistics([`_${username}`], signal)

            return result[username] ?? EMPTY_STATISTICS
        },
        enabled: enabled && Boolean(username),
        staleTime: StaleTime.Short,
    })
}
